module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/suez-white.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Les cantonniers, SUEZ")]), _vm._v(" "), _c('h3', [_vm._v("Back Office")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "ui form loginForm"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Login",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Mot de passe",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v("Se souvenir de moi\n          ")])]), _vm._v(" "), (_vm.login.message !== null) ? _c('div', {
    class: 'callout callout-' + _vm.login.message.type
  }, [_c('p', [_vm._v(_vm._s(_vm.login.message.text))])]) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn) ? _c('div', {
    staticClass: "callout callout-success"
  }, [_c('p', [_vm._v("Bienvenue !")])]) : _vm._e()]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v(" > Mot de passe oublié ? ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("S'authentifier")])]), _vm._v(" "), _c('a', {
    staticClass: "transparent-button",
    on: {
      "click": _vm.handleButtonClick
    }
  }, [_vm._v("\n      Politique de confidentialité\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77225b3b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 2118
// module chunks = 2